import { CountryISOCodes } from 'common/countries';

export const supportedCurrencies = ['USD', 'EUR', 'GBP', 'CAD'];

const defaultCountryISOCode = CountryISOCodes.USA;

const currencyByCountry: Record<string, string> = {
  [CountryISOCodes.USA]: 'USD',
  [CountryISOCodes.Canada]: 'CAD',
  [CountryISOCodes.UnitedKingdom]: 'GBP',
};

export const getCurrencyByCountry = (
  countryIsocode?: CountryISOCodes,
): string => {
  return currencyByCountry[countryIsocode || defaultCountryISOCode];
};
